export const StructDefaultOptions = {
    littleEndian: false,
};
//# sourceMappingURL=options.js.map